/** @module csi/task/PriorityIconRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/widget/CustomIconWithLabel",
	"csi/xml"
], function(declare, Enum, CustomIconWithLabel, xml) {

	const ICON_MAP = {
		1: "critical",
		2: "high",
		3: "medium",
		4: "low",
		5: "minor"
	};

	return declare(Enum, {
		/**
		 * Return the priority id based on the current context
		 * @param {Context} ctx
		 * @return {string}
		 */
		getPriorityId: function(ctx) {
			return ctx.getNode().Id;
		},

		/**
		 * Return the priority icon based on the given key
		 * @param {string} ctx
		 * @return {string}
		 */
		getPriorityIcon: function(key) {
			return ICON_MAP[key];
		},

		/**
		 * @override
		 * Draw material icon corresponding to given Camunda task priority value
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const priorityId = this.getPriorityId(ctx);
			const priorityText = xml.enumGetText(priorityId);

			new CustomIconWithLabel({
				icon: this.getPriorityIcon(priorityText),
				inline: true,
				label: ""
			}).placeAt(refNode);

			return true;
		},

		/** React */

		/**
		 * @override
		 * @param {context} ctx
		 * @return {string}
		 */
		getReactControlType: function(ctx) {
			return "csi/task/PriorityIconInlineSelect";
		},

	});
});